
<template>
    <div class="animated fadeIn">
   
    <b-row >
       
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
         <!--  <div slot="header">
            <strong>Status Report</strong> 
             </div> -->


          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
          <b-row style="margin-top:-5%">
          
         <b-col md="12" class="my-1">

          
            <b-row class="form-group">

                 <b-col sm="4">

                <div id='container' style="margin:50px auto 0; width:250px;">
                <br>     
                  <b-form-group label="Status Type:" :label-cols="5" >
                  <b-form-select v-model="shipmentstatus" name="shipmentstatus" class="mySelectBox" v-validate="'required'" :onclick="status()">
                    <option value="">--Selected Type-</option>
                    <option value="OFD">OFD</option>
                    <option value="INTransit">INTransit</option>
                    <option value="Delivered">Delivered</option>
                    <option value="HandoverPending">HandoverPending</option>
                  </b-form-select>
                </b-form-group>
                </div>
                               
              </b-col>
             
                <b-col sm="4">

                <div id='container' style="margin:50px auto 0; width:250px;">
                <br>     
                  <b-form-group label="Custom Type:" size="sm" :label-cols="5" >
                  <b-form-select name="customtype" class="mySelectBox" v-validate="'required'" v-model="selected">
                    <option value="">--Select Custom--</option>
                    <option value="0">Riderwise</option>
                    <option value="1">Shipmentwise</option>
                  </b-form-select>
                </b-form-group>
                </div>
                               
              </b-col>
              <b-col sm="4">
                 <div id='container' class="datepicker">
                   <b-form-group label="Select Date:"  :label-cols="4"  >

                   <v-date-picker  mode='single'  :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                      </v-date-picker>

                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </div>
                </b-col>  

              </b-row>
              
              <b-row class="form-group" v-if="selected === '0'">
             
              <b-col sm="6">
                <b-col sm="12">
                <div  id='container' style="margin:50px auto 0; width:400px;">
                <br>     
                <b-form-group label="Delivery Agent"  label-size="md"
                      :label-cols="4" >  
                                     
                      <v-select id="mySelect" v-model="deliveryagentid" :options="this.data1" placeholder="Select Delivery Agent" name="deliveryagentid" v-validate="'required'" :class="{ danger: errors.has('deliveryagentid') }"
                      style="width:190px">
                      </v-select>
                  
                      <span v-show="errors.has('deliveryagentid')" class="danger">
                          {{ errors.first('deliveryagentid') }}
                      </span>    
                    </b-form-group>  

                <!-- <b-form-group label="Delivery Agent:" :label-cols="6" >
                 <b-form-select class="form-control input"  v-model="deliveryagentid" name="deliveryagentid"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentid') }"  >
                        <option value="" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}</option>
                  </b-form-select>
               </b-form-group>
               <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('deliveryagentid')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.deliveryagentid')" class="help text-danger">{{ errors.first('form-1.deliveryagentid') }}</span>
                      </b-input-group> -->

                </div>
              </b-col>
                               
              </b-col>
              <!-- @click="showlist(0)" -->
              <b-col sm="4">
                <div  id='container' class="deliveryagentbox">
                <b-button  type="submit" size="md" variant="primary" > Add</b-button>
                </div>      
              </b-col>
               
            </b-row>  

              <b-row class="form-group" v-if="selected === '1'">
              <b-col sm="4">
                 <b-col sm="12">
                <div id='container' style="margin:50px auto 0; width:350px;"> 
                <br> 
                  <b-form-group label="Shipping Id : " :label-cols="4">
                 
                <vue-tags-input v-model="customer.shippingid" name="shippingid" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.customer.shippingid') }" :tags="tags" @tags-changed="newTags => tags = newTags  " :avoidAddingDuplicates="avoidAddingDuplicates" :placeholder="placeholder" ref="taginput" v-bind:separators="[',', ';']"/>
                   <span class="badge badge-success1">&nbsp;</span>&nbsp;
                   <label :label-cols="4" >Unique Shipping Id</label><br>
                   <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                    <!-- <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span> -->
                  </b-form-group>
                   <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('customer.shippingid')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.customer.shippingid')" class="help text-danger">{{ errors.first('form-1.customer.shippingid') }}</span>
                      </b-input-group>
                </div>
                 </b-col>
              </b-col>
               <!-- @click="showlist(1)" -->
               <b-col sm="4">
                 <div  id='container' class="shippingbox">
                <b-button  @click="showlist()" type="submit" size="md" variant="primary"> Add</b-button>  
                </div>    
              </b-col>
            </b-row>  
                     
                         
          </b-col>      
        </b-row> 
          </b-form>
             
        <!-- <b-row class="mb-4">                  
           <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>        
        </b-row> -->

        <!-- <b-table show-empty stacked="md"  style="text-align: left" :items="items"   :fields="fields"   :current-page="currentPage" :bordered="bordered" :per-page="perPage"  :filter="filter"       thead-class="hidden_header"  @filtered="onFiltered"     :busy="isBusy" >
         
          <template slot="top-row" >
             <td  class="totalback" v-for="record in totalRows" ><b>{{record}}</b></td>
          
          
   
    </template>
          
         
                      
                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>     
                  </b-table>  -->
            

                    
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination>
          </b-col>  

        </b-card>
       
      </b-col>
    <!-- </b-row> 
        <b-row> -->
     <!--  <b-col lg="12">
       <b-card header-tag="header" footer-tag="footer"> -->
            
      <!--  </b-card>
        
      </b-col> -->
    </b-row><!--/.row-->
  </div>   
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueBarcode from 'vue-barcode';
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    VueTagsInput,
  },
  data: function() {
    return {
      data: [],
      checkedShipmentID:[],
      items:[],
      selected:'',
      isBusy: false,
      showSelectAll : true,
      allowCustomValue : true,
      agentid:[],
      statusoptions:[],
      value4:[],
      placeholder:"Add shippingid",
      customer: {},
      shippingid: '',
      tags: [],
      options: [],
      agentmaster: [],
      deliveryagentid:'',
      selectedDate: new Date(),
      avoidAddingDuplicates:false,
      shipmentstatus:'',
      // fields: [
      //     // { key: 'checkbox', label: 'Select', sortable: true},
      //     { key: 'orderid', label: 'Orderid', sortable: true, sortDirection: 'desc' },
      //     { key: 'awbno', label: 'AWBno', sortable: true},
      //     { key: 'customername', label: 'Customername', sortable: true},
      //     { key: 'futuredate', label: 'FutureDeliveryDate', sortable: true},
      //     { key: 'deliverystatus', label: 'DeliveryStatus', sortable: true },
      //     { key: 'shipmentstatus', label: 'ShipmentStatus', sortable: true },

      //   ],
      fields: { text: 'name', value: 'id' },
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
    };
  },
 
  computed: {
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.displaydeliveryagent();
    
  },
  methods: {
    info(item, shipmentid,index, button) {

      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },



    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
   validateForm(scope) {
     // alert(" i m in ");
    
      this.$validator.validateAll(scope).then(result => {
        if (result) { 
         // alert(" i m in alert");         
          this.showlist();
        }
      });
    },

    showlist: function() {
      // alert("Shipmenywise")
      // alert(value);
       this.isBusy = true;
       if(this.selected=='0'){
        // alert(this.selected);
    var fromdate = this.formatDate(this.selectedDate);
    this.deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
    var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        var csvObj = {
          deliveryagentmasterid:this.deliveryagentid.key,
          shippingid:'',
          shipmentstatus:shipmentstatus,
          fromdate: `${fromdate}`,
        };
      }
      if(this.selected=='1'){
        // alert(this.selected);
        var shipmentid=[];
       for(var i = 0; i < this.tags.length; i++) {
          shipmentid.push(this.tags[i].text);  
       }
    var fromdate = this.formatDate(this.selectedDate);
    this.deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
    var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        var csvObj = {
          deliveryagentmasterid:'',
          shippingid:shipmentid,
          shipmentstatus:shipmentstatus,
          fromdate: `${fromdate}`,
        };
      }
      // console.log("csvObj",csvObj);
      // return false;

          // this.$http.post(`${CONSTANTS.API_URL}/pushStausToCustom`,csvObj)  /FastBees
           // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/menuaccesslisting`,obj)
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/pushStatusToCustom`,csvObj).then(result => {
            // console.log("Result",result);
          if (result.body.returnmsg=="Successful") {
               // Utils.notify("Added successfully", "success"); 
              //  alert("Added successfully");
                this.$fire({
                  text: "Added Successfully",
                  type: "success",
                  timer: 30000
                });
                this.customer = {};
                this.tags=[];
                
              } else {
                // alert(result.body.returnmsg);
                this.$fire({
                  text: result.body.returnmsg,
                  type: "error",
                  timer: 30000
                });
                // Utils.notify(result.body.returnmsg, "error");
                
              }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });

    },

    

    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
         deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
         isactive: '1',
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          // this.agentmaster = result.body
          this.data1 = result.body

           var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' '+srData.deliveryagentlastname
                });
              });
              this.data1 = data;
          // console.log("delivery11",this.data1);
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    // displaydeliveryagent: function() {
    //   var userdata = localStorage.getItem('userData')
    //   var userInfo = JSON.parse(userdata)
    //   //agentmaster

    //   const deliveryagent = {
    //     deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
    //     isactive: '1'
    //   }
    //   this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
    //     .then((result) => {
    //       this.agentmaster = result.body
    //     })
    //     .catch((ex) => {
    //       console.log('error', ex)
    //     })
    // },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    status: function() {

    if(this.shipmentstatus=="OFD")
     {

     var csvObj = {

          shipmentstatus:"OFD"

        };

      }
      else if(this.shipmentstatus=="INTransit")
      {

      var csvObj = {

        shipmentstatus:"INTransit"

      }; 

      }
       else if(this.shipmentstatus=="Delivered")
      {

      var csvObj = {

        shipmentstatus:"Delivered"

      };

      }
       else if(this.shipmentstatus=="HandoverPending")
      {

      var csvObj = {

        shipmentstatus:"HandoverPending"

      };

      }
     },


  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}

@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
.addpad{
  padding: 10px;
}    
.datepicker{
  margin:50px auto 0;
   width:250px; 
   margin-top: 70px;
   position: relative;
}  
.shippingbox{
  margin:50px auto 0;
  width:250px;
  margin-top: 213px;
  position: relative;
}  
.deliveryagentbox{
  margin:50px auto 0; 
  width:250px; 
  margin-top: 70px;
  position: relative;
}
</style>

